import { Box } from "@chakra-ui/react";
import { PresenceType } from "@keita/lanepatrol-sdk";
import { CraColoringLegendItem } from "./CraColoringLegendItem";
import {
  mapGradientEnd,
  mapGradientStart,
} from "../../../../map/utils/map-utils";
import { CraAttributeUtils } from "../../../../coding/utils/attribute-utils";

export const CraColoringTreatment: React.FC = () => {
  return (
    <Box>
      <CraColoringLegendItem color={mapGradientStart}>
        {CraAttributeUtils.getOptionLabel(PresenceType.Present)}
      </CraColoringLegendItem>
      <CraColoringLegendItem color={mapGradientEnd}>
        {CraAttributeUtils.getOptionLabel(PresenceType.NotPresent)}
      </CraColoringLegendItem>
    </Box>
  );
};
